export const envType = {
    'MOCK': 1,
    'LOCAL': 2,
    'DEV': 3,
    'PROD': 4
};
const env = envType.PROD;

export default env;